import React, { useState } from 'react';
import Modal from '../components/Modal/Modal';
import AddEntity from '../components/AddEntity/AddEntity';
import ApiManager from '../ApiManager/ApiManager';

const LabelFields = [
    { label: 'Name', name: 'name', type: 'text', required: true },
    { label: 'Description', name: 'description', type: 'text', required: true },
    { label: 'Location', name: 'location', type: 'text', required: true }
];



const NewFuelStation = ({onSuccess}) => {
    const [isModalOpen, setModalOpen] = useState(false);

    const toggleModal = () => {
        setModalOpen(!isModalOpen);
    };

    return (
        <div>
            <div className="newCar-bar">
                <button className="custom-button" onClick={toggleModal}>
                    New Fuel Station
                </button>
            </div>
            <Modal isOpen={isModalOpen} onClose={toggleModal}>
                <AddEntity
                    toggleFunction={toggleModal}
                    title="Add Fuel Station"
                    formFields={LabelFields}
                    apiFunction={ApiManager.addFuelStation}
                    onSuccess={onSuccess}
                />
            </Modal>
        </div>
    );
};

export default NewFuelStation;
